import React, { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { optionType, valueType } from './type';
import Option from './Option';
import isSelected from '../../utilities/isSelected';

const Options = ({ options, optionProps, snapshot, renderBottom, facetId }) => {
	const selectRef = useRef(null);
	const { value, highlighted } = snapshot;

	useEffect(() => {
		const { current } = selectRef;

		if (!current || (highlighted < 0 && value === null)) {
			return;
		}

		const val = value;
		const query =
			highlighted > -1
				? `[data-index="${highlighted}"]`
				: `[data-value="${escape(val)}"]`;
		const selected = current.querySelector(query);

		if (selected) {
			const rect = current.getBoundingClientRect();
			const selectedRect = selected.getBoundingClientRect();

			current.scrollTop =
				selected.offsetTop - rect.height / 2 + selectedRect.height / 2;
		}
	}, [value, highlighted, selectRef]);

	return (
		<div className="select-options" ref={selectRef}>
			{options.length && (
				<ul className="options">
					{options.map((o) => {
						return (
							<Option
								key={o.value}
								facetId={facetId}
								selected={isSelected(o, snapshot.option)}
								highlighted={snapshot.highlighted === o.index}
								option={o}
								optionProps={optionProps}
							/>
						);
					})}
					{renderBottom && (
						<li role="menuitem" key="bottom-render">
							{renderBottom()}
						</li>
					)}
				</ul>
			)}
		</div>
	);
};

Options.propTypes = {
	facetId: PropTypes.string,
	options: PropTypes.arrayOf(optionType).isRequired,
	optionProps: PropTypes.shape({
		tabIndex: PropTypes.string.isRequired,
		onMouseDown: PropTypes.func.isRequired
	}).isRequired,
	snapshot: PropTypes.shape({
		highlighted: PropTypes.number.isRequired,
		value: valueType,
		option: optionType
	}).isRequired,
	renderBottom: PropTypes.func
};

export default memo(Options);
